module.exports = __webpack_public_path__ + "img/water1.dea61a41.png";